import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import EcoPilot from '../../components/feature/EcoPilot';
import AboutContent from './components/AboutContent';

export default function About() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <AboutContent />
      </main>
      <Footer />
      <WhatsAppButton />
      <EcoPilot />
    </div>
  );
}